import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

export interface selectedItem{key: any, value: string, view: string, title: string}

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css']
})
export class SelectComponent implements OnInit, OnChanges {

  @Input() addNull: boolean | undefined;
  @Input() nullValue: string | undefined;
  @Input() placeholder : string | undefined;
  @Input() options: any[] | undefined;
  @Input() key: string | undefined;
  @Input() value: string | undefined;
  @Input() title: string | undefined;
  @Input() functionValue: any | undefined;
  @Input() selectedKey: any | null | undefined;
  @Input() disabled: boolean | undefined;
  @Input() style: any;
  @Input() valClass: any;


  @Output() change : EventEmitter<selectedItem> = new EventEmitter();

  listItems : selectedItem[] = [];
  selected: selectedItem | undefined;

  constructor() { }
  
  ngOnInit(): void {
    this.generateObjSelect();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.options){
      this.selected = undefined;
      this.options = changes.options.currentValue;
      this.generateObjSelect();
    } else if(changes.functionValue){
      this.functionValue = changes.functionValue.currentValue;
      this.generateObjSelect();
    }
    if(changes.selectedKey){
      this.selectedKey = changes.selectedKey.currentValue;
      this.generateObjSelect();
    }

    if(changes.disabled){
      this.disabled = changes.disabled.currentValue;
    }
    if(changes.style){
      this.style = changes.style.currentValue;
    }
    
  }


  private generateObjSelect(){
    this.listItems = [];
    if(this.addNull){
      this.listItems.push({key:'', value: this.nullValue ? this.nullValue : '(nessuno)', view: this.nullValue ? this.nullValue : '(nessuno)', title: this.nullValue ? this.nullValue : '(nessuno)'});
    }
    if(this.options && !this.key && !this.value){
      this.options!.forEach(async o => {
        if(!this.functionValue){
          this.listItems.push({key: o, value: o, view: o, title: o});
        } else {
          this.listItems.push({key: o, value: o, view: await this.functionValue(o), title: o});
        }
      })
    } else {
      if(this.options && this.key && (this.value || this.functionValue)){
        this.options.forEach(async o => {
          if(!this.functionValue){
            this.listItems.push({key: o[this.key!], value: o[this.value!], view: o[this.value!], title: o[this.value!]});
          } else {
            this.listItems.push({key: o[this.key!], value: o[this.value!], view: await this.functionValue(o), title: o[this.value!]});
          }
        })
      }
    }
    if(this.selectedKey != undefined){
      try {
        this.selected = this.listItems.filter(o => o.key == this.selectedKey)[0];
      } catch (error) {
      }
      if(!this.selected){
        this.selected = undefined;
      }
    } else if(this.addNull){
      this.selected = this.listItems.filter(o => o.key == '')[0];
    }
    if(this.listItems.length == 1){
      this.selected = this.listItems[0];
      this.change.emit(this.selected);
    }
  }

}
